import { z } from "zod";

export const HUBSPOT_COMPANY_PRELOAD_LIMIT = 100;

const HUBSPOT_COMPANY_PRELOAD_SEGMENTS = [
  "customer-or-opportunity",
  "customer",
  "without-risk",
  "non-customer",
  "with-deals",
] as const;

export type HubSpotCompanyPreloadSegment =
  (typeof HUBSPOT_COMPANY_PRELOAD_SEGMENTS)[number];

export interface CompanyPreloadOptions {
  companyPreloadSegment?: HubSpotCompanyPreloadSegment;
}

export const COMMERCIAL_COMPANY_PRELOAD_SEGMENTS = {
  altaOportunidad: "customer-or-opportunity",
  altaPropuesta: "with-deals",
  altaAprobacionComercial: "with-deals",
} as const satisfies Record<string, HubSpotCompanyPreloadSegment>;

const companyPreloadSegmentSchema = z.enum(HUBSPOT_COMPANY_PRELOAD_SEGMENTS);
const externalPayloadSchema = z.unknown();
type ExternalPayload = z.input<typeof externalPayloadSchema>;

export function isHubSpotCompanyPreloadSegment(
  value: ExternalPayload,
): value is HubSpotCompanyPreloadSegment {
  return companyPreloadSegmentSchema.safeParse(value).success;
}
